export default "__VITE_ASSET__CfuWo1$q__"